import React from 'react'

export const defaultTwitterImage = (
  <meta
    name="twitter:image"
    content="https://images.ctfassets.net/5965pury2lcm/1OVj4PfkzVc4Vrm3IuDdAP/f415d995e5a286ddb2644cabafeb9578/UiPath-og-image-orange.png"
    key="twitter-image-tag"
  />
)

export const defaultOGImage = (
  <meta
    property="og:image"
    content="https://images.ctfassets.net/5965pury2lcm/1OVj4PfkzVc4Vrm3IuDdAP/f415d995e5a286ddb2644cabafeb9578/UiPath-og-image-orange.png"
    key="og-image-tag"
  />
)

export const defaultDescriptionTag = (
  <meta
    name="description"
    content="UiPath is a leading Robotic Process Automation vendor providing a complete software platform to help organizations efficiently automate business processes."
    key="description-tag"
  />
)

export const defaultOGDescription = (
  <meta
    property="og:description"
    content="UiPath is a leading Robotic Process Automation vendor providing a complete software platform to help organizations efficiently automate business processes."
    key="og-decription-tag"
  />
)

export const defaultTwitterDescription = (
  <meta
    name="twitter:description"
    content="UiPath is a leading Robotic Process Automation vendor providing a complete software platform to help organizations efficiently automate business processes."
    key="twitter-description-tag"
  />
)

export const defaultOGTitle = (
  <meta property="og:title" content="Robotic Process Automation | UiPath" key="og-title-tag" />
)

export const defaultTwitterTitle = (
  <meta
    name="twitter:title"
    content="Robotic Process Automation | UiPath"
    key="twitter-title-tag"
  />
)

export const defaultRobotsTag = <meta name="robots" content="index, follow" key="robots-tag" />
export const defaultTitleTag = <title key="title-tag">Robotic Process Automation | UiPath</title>
export const defaultLang = <html lang="en" key="html-lang-tag" />
